import { Check } from 'lucide-react';

import styles from './ChecklistItem.module.css';

interface ChecklistItemProps {
  children: string;
}

export function ChecklistItem({ children }: ChecklistItemProps) {
  return (
    <li className={styles.item}>
      <span aria-hidden="true" className={styles.icon}>
        <Check size={18} strokeWidth={2.4} />
      </span>
      <span>{children}</span>
    </li>
  );
}
